<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Configure Approval Workflow
							</div>
				
							<div class="page_main">
								<div class="btn_el">
									<div class="tips">
										Please manually configure the approval workflow for document operations under the selected document type.
									</div>
									<div class="tips">
										• Click <strong>"Add Approval Step"</strong> to add an approval step.
									</div>
									<div class="tips">
										• Click <strong>"Add CC Step"</strong> to add a CC step.
									</div>
									<div class="tips">
										• Click <strong>"Edit"</strong> to modify the workflow.
									</div>
									<div class="tips">
										• Click <strong>"Delete"</strong> to remove a workflow step.
									</div>
									<div class="tips">
										• Approval workflows currently support a maximum of three approval levels.
									</div>
								</div>
				
								<!-- Toolbar -->
								<div class="search_box">
									<div class="btn_box">
										<van-button
											class="btn_el2"
											round
											color="linear-gradient(to right, #7BC1FF, #4886FF)"
											@click="handleClick('Add Approval')"
										>
											Add Approval Step
										</van-button>
				
										<van-button
											class="btn_el2"
											round
											color="linear-gradient(to right, #7BC1FF, #4886FF)"
											@click="handleClick('Add CC Step')"
										>
											Add CC Step
										</van-button>
				
										<van-button
											class="btn_el2"
											type="default"
											round
											@click="cancel"
										>
											Cancel
										</van-button>
									</div>
								</div>
				
								<!-- Table -->
								<div class="table_box">
									<el-table
										v-loading="tableLoading"
										:data="tableData"
										border
										class="table_el"
										ref="multipleTable"
										header-cell-class-name="table-header"
									>
				
										<el-table-column prop="id" label="Action" width="80" align="center">
											<template #default="scope">
												<div class="inline_btn">
													<el-button
														type="primary"
														size="mini"
														@click="handleClick('Edit', scope.row)"
													>
														Edit
													</el-button>
												</div>
											</template>
										</el-table-column>
				
										<el-table-column
											prop="leixing_name"
											label="Document Type"
											width="150"
											:show-overflow-tooltip="true"
										/>
				
										<el-table-column
											label="Step Type"
											width="100"
											align="center"
											:show-overflow-tooltip="true"
										>
											<template #default="scope">
												<div v-if="scope.row.flow_leixing == 1">
													<el-tag type="success">Approval</el-tag>
												</div>
												<div v-if="scope.row.flow_leixing == 2">
													<el-tag type="warning">CC</el-tag>
												</div>
											</template>
										</el-table-column>
				
										<el-table-column
											prop="title"
											label="Step Name"
											width="150"
											:show-overflow-tooltip="true"
										/>
				
										<el-table-column
											label="Step Description"
											:show-overflow-tooltip="true"
											width="150"
										>
											<template #default="scope">
												{{ scope.row.prompt || '/' }}
											</template>
										</el-table-column>
				
										<el-table-column
											label="Approval / CC Type"
											width="210"
											:show-overflow-tooltip="true"
										>
											<template #default="scope">
												<div v-if="scope.row.flow_type == 1">
													Company Manager
												</div>
												<div v-if="scope.row.flow_type == 2">
													Management Representative
												</div>
												<div v-if="scope.row.flow_type == 3">
													Department Manager
												</div>
											</template>
										</el-table-column>
				
										<el-table-column
											label="Department"
											:show-overflow-tooltip="true"
										>
											<template #default="scope">
												<div v-if="scope.row.flow_type == 3">
													{{ scope.row.flow_ids_name || '/' }}
												</div>
												<div v-else>
													{{ scope.row.flow_ids_name || '/' }}
												</div>
											</template>
										</el-table-column>
				
										<el-table-column
											label="Approver / CC Recipient"
											width="210"
											:show-overflow-tooltip="true"
										>
											<template #default="scope">
												{{ scope.row.flow_uid_name || '/' }}
											</template>
										</el-table-column>
				
										<el-table-column
											prop="id"
											label="Action"
											width="80"
											align="center"
										>
											<template #default="scope">
												<div class="inline_btn">
													<el-button
														type="danger"
														size="mini"
														@click="handleClick('Delete', scope.row)"
													>
														Delete
													</el-button>
												</div>
											</template>
										</el-table-column>
				
									</el-table>
								</div>
								<!-- End Table -->
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--添加编辑-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
			<addEdit
				v-if="dialogVisible"
				:leixingId="query.leixing_id.toString()"
				:flowType="flowType"
				:listData="listData"
				:leixingTpye="leixingTpye"
			></addEdit>
		</el-dialog>
		<!--添加编辑-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { flowList, flowDel } from '@/api/docManage/configureDocControl/docFlow/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import addEdit from "./add-edit.vue";
export default {
	components:{
		headers,
		slider,
		addEdit
	},
	data() {
		return {
			isLoading: true,
			query: {
				leixing_id: '',
				page: 1,
				page_size: 9999
			},
			tableLoading: false,
			tableData: [],
			dialogTitle: '',
			dialogVisible: false,
			flowType: null,
			listData: null,
			leixingTpye: null
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		that.query.leixing_id = that.$route.query.oid;
		that.getTableData();
	},
	watch: {
		//
	},
	methods: {
		//获取表格数据
		getTableData() {
			let that = this;
			that.tableLoading = true;
			flowList(that.query).then(res => {
				that.tableLoading = false;
				if(res.code == 200) {
					that.pageTotal = res.data.total;
					that.tableData = res.data.data;
					// that.handleClick('编辑', that.tableData[0]);
				}else {
					
				}
			});
		},
		//操作按钮点击
		handleClick(name, value) {
			let that = this;
			switch (name) {
				case 'Add Approval':
					let count = 0;
					that.tableData.forEach((value, index) => {
						if(value.flow_leixing == 1) { count++; }
					});
					if(count >= 3) {
						that.$message('Approval steps do not currently support more than three levels.');
					}else {
						that.leixingTpye = 1;  //审批
						that.flowType = 'Add';
						that.dialogTitle = 'Add Step';
						that.dialogVisible = true;
					}
				break;
				case 'Add CC Step':
					that.leixingTpye = 2;  //抄送
					that.flowType = 'Add';
					that.dialogTitle = 'Add Step';
					that.dialogVisible = true;
				break;
			    case 'Edit':
					that.flowType = 'Edit';
					that.dialogTitle = 'Edit Step';
					that.listData = value;
					that.dialogVisible = true;
				break;
				case 'Delete':
					that.$confirm('Delete this step?', 'Confirmation', {
						type: 'warning'
					}).then(() => {
						that.$toast.loading({ duration: 0, forbidClick: true });
						flowDel({ id: value.id }).then(res => {
							that.$toast.clear();
							that.$message.success('Operation successful');
							that.getTableData();
						});
					}).catch(() => {
						// that.$message({ type: 'info', message: '您已取消退出登录' });
					});
				break;
			}
		},
		//取消
		cancel() {
			this.$router.back();
		},
	}
}
</script>

<style lang="less" scoped>
//主要内容
.main_main{
	.page_main{
		padding: 18px 20px;
		//表格
		.table_box{
			width: 100%;
			padding-top: 20px;
			.inline_btn{
				display: inline-block;
			}
			.pagination {
				margin: 10px 0;
				text-align: right;
			}
			.mr_l{
				margin-left: 10px;
			}
		}
		//搜索
		.search_box{
			.search_el{
				display: flex;
				padding-bottom: 10px;
				.search_el_el{
					flex: 1;
				}
				.mr_r{
					margin-right: 10px;
				}
				.mr_l{
					margin-left: 10px;
				}
			}
		}
		.btn_box{
			text-align: right;
			.btn_el2{
				margin-left: 10px;
				padding: 12px 24px;
				.van-button__text{
					font-size: 16px;
				}
			}
		}
		.btn_el{
			margin: 10px 0 20px 0;
			border-radius: 6px;
			background-color: #ffb1001a;
			padding: 10px 8px;
			.tips{
				padding: 2px 0;
				font-size: 16px;
				font-weight: bold;
			}
		}
	}
	//页头
	.page_header{
		padding: 0 20px;
		height: 60px;
		line-height: 60px;
		background-color: #d8e4f0;
		font-size: 24px;
		font-weight: bold;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
	}
}
</style>
<style scoped>
.main_box{
	height: calc(100vh - 60px);
	overflow-y: auto;
}
.main_box .main_main{
	position: relative;
	min-height: calc(100% - 0px);
	max-height: auto;
	background-color: #FAFAFA;
}
.el-header, .el-main{
	padding: 0;
}
::v-deep .table_box .inline_btn .el-button{
	padding: 2px 6px;
}
</style>

